import React, {forwardRef, useImperativeHandle} from "react";
import ConstructiveFeedbackModal from "./ConstructiveFeedbackModal";
import useModalSetup from "../../../../../../../hooks/useModalSetup";

export const ConstructiveFeedbackEntry = forwardRef(({}, ref) => {
    const {handleOpenModal, handleCloseModal, openModal} = useModalSetup();

    useImperativeHandle(ref, () => ({
        open() {
            handleOpenModal();
        }
    }));

    return(
        <ConstructiveFeedbackModal
            title={'Constructive feedback'}
            open={openModal}
            handleClose={handleCloseModal}
        />
    )
});